<template>
  <div class="project-limits-handbook">
    <PageTitle hideMarginLeft>Настройка лимитов по проекту</PageTitle>
    <div class="tw-pt-4">
      <div class="filters row q-gutter-md q-mb-md">
        <div class="filter-item">
          <CustomSelect
            label="Проект"
            :required="true"
            placeholder="Выберите проект"
            :options="projectsOptions"
            option-value-key="sbs_project_id"
            option-label-key="sbs_project_name"
            :value="filters.sbs_project_id"
            @change="(val) => onFilterChange('sbs_project_id', val)"
          />
        </div>
        <div class="filter-item">
          <CustomSelect
            label="Конструктив"
            :required="true"
            placeholder="Выберите конструктив"
            :options="constructivesOptions"
            option-value-key="project_type_id"
            option-label-key="project_type_name"
            :value="filters.project_type_id"
            @change="(val) => onFilterChange('project_type_id', val)"
          />
        </div>
      </div>

      <q-linear-progress v-if="isProjectsLoading || isConstructivesLoading" indeterminate class="tw-mb-4" />

      <ProjectLimitsTable
        v-else-if="filters.sbs_project_id && filters.project_type_id"
        :sbs-project-id="filters.sbs_project_id"
        :project-type-id="filters.project_type_id"
        :project-name="selectedProjectName"
        :constructive-name="selectedConstructiveName"
      />
      <div v-else class="tw-text-grey-6 tw-py-8 tw-text-center">
        Выберите проект и конструктив для отображения таблицы
      </div>
    </div>
  </div>
</template>

<script setup>
import PageTitle from "@/components/common/PageTitle.vue";
import CustomSelect from "@/components/form/CustomSelect";
import ProjectLimitsTable from "./ProjectLimitsTable.vue";
import { useQuery } from "@tanstack/vue-query";
import { ref, reactive, computed } from "vue";
import { getSbsProjects, getProjectTypes } from "./services";

const filters = reactive({
  sbs_project_id: null,
  project_type_id: null,
});

const { data: projectsData, isLoading: isProjectsLoading } = useQuery({
  queryKey: ["sbsProjectsList"],
  queryFn: getSbsProjects,
  refetchOnWindowFocus: false,
});

const { data: constructivesData, isLoading: isConstructivesLoading } = useQuery({
  queryKey: ["projectTypesList"],
  queryFn: getProjectTypes,
  refetchOnWindowFocus: false,
});

const projectsOptions = computed(() => projectsData.value || []);
const constructivesOptions = computed(() => constructivesData.value || []);

const selectedProjectName = computed(() => {
  const id = filters.sbs_project_id;
  if (!id) return "";
  const p = projectsOptions.value.find((x) => x.sbs_project_id === id);
  return p?.sbs_project_name || "";
});

const selectedConstructiveName = computed(() => {
  const id = filters.project_type_id;
  if (!id) return "";
  const c = constructivesOptions.value.find((x) => x.project_type_id === id);
  return c?.project_type_name || "";
});

function onFilterChange(key, value) {
  filters[key] = value ?? null;
}
</script>

<style lang="scss" scoped>
.project-limits-handbook {
  min-height: 400px;
}

.filters {
  .filter-item {
    min-width: 280px;
  }
}
</style>
